import { render, staticRenderFns } from "./KeywordListItem.vue?vue&type=template&id=c208c472&scoped=true&"
import script from "./KeywordListItem.vue?vue&type=script&lang=js&"
export * from "./KeywordListItem.vue?vue&type=script&lang=js&"
import style0 from "./KeywordListItem.vue?vue&type=style&index=0&id=c208c472&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c208c472",
  null
  
)

export default component.exports